<template>
  <div class="privacidad-page">
    <div class="privacidad-img-placeholder">
      <img
        src="https://atriainnovation.com/uploads/2023/11/portada-industria-4.jpg"
        alt="Industria 4.0"
        class="privacidad-img"
      />
    </div>
    <div class="privacidad-title-card">
      <h1>{{ content.title }}</h1>
    </div>
    <div class="privacidad-main">
      <div class="privacidad-intro">
        {{ content.intro }}
      </div>
      <div v-for="(section, idx) in content.sections" :key="idx" class="privacidad-section">
        <div class="privacidad-section-heading">{{ section.heading }}</div>
        <pre class="privacidad-section-text">{{ section.text }}</pre>
      </div>
    </div>
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { privacidadContent } from '@/assets/data/data.ts';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'AvisoDePrivacidad',
  components: { SiteFooter },
  props: {
    selectedLang: {
      type: String,
      default: 'es'
    }
  },
  setup() {
    useSEO({
      title: 'Aviso de Privacidad',
      description: 'Política de privacidad y protección de datos personales de Frenkel Engineering. Conoce cómo tratamos y protegemos tu información.',
      path: '/aviso-privacidad',
    });
  },
  computed: {
    content() {
      return privacidadContent[this.selectedLang] || privacidadContent.es;
    }
  }
};
</script>

<style scoped>
.privacidad-page {
  min-height: 100vh;
  background: #f6fafb;
  font-family: 'IBM Plex Mono', monospace;
  display: flex;
  flex-direction: column;
}
.privacidad-img-placeholder {
  width: 100%;
  height: 200px;
  background: #fff;
  border: 3px solid #222;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.privacidad-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.privacidad-title-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 16px 2px #9992;
  margin: -40px auto 0 auto;
  width: 72vw;
  min-width: 320px;
  max-width: 700px;
  padding: 0.8rem 0.2rem 0.6rem 0.2rem;
  text-align: justify;
  z-index: 3;
  position: relative;
}
.privacidad-title-card h1 {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.4rem;
  font-weight: bold;
  margin: 0;
}
.privacidad-main {
  width: 98vw;
  max-width: 820px;
  margin: 1.5rem auto 0 auto;
  background: none;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
}
.privacidad-intro {
  margin-bottom: 16px;
  margin-top: 12px;
  white-space: pre-line;
}
.privacidad-section {
  margin-bottom: 1.5rem;
}
.privacidad-section-heading {
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.privacidad-section-text {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  white-space: pre-line;
  background: none;
  border: none;
  margin: 0 0 0.7rem 0;
  padding: 0;
  color: #222;
}
@media (max-width: 700px) {
  .privacidad-title-card {
    width: 96vw;
    padding: 0.7rem 0.1rem 0.4rem 0.1rem;
    min-width: unset;
  }
  .privacidad-main {
    width: 98vw;
    padding: 0 2vw;
    font-size: 0.96rem;
  }
  .privacidad-img-placeholder {
    height: 120px;
  }
}
</style>
